import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import Multiselect from "multiselect-react-dropdown";
import { Pdf, Jpg, Png, Jpeg } from "../../assets/icons";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import DrawPolygon from "../DrawPolygon";

export default function LeadsDetails() {
  const { id, marketingPartnerID } = useParams();
  const location = useLocation()

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [user, setUser] = useState({});
  const [cordinates, setCordinates] = useState([]);
  const [iState, updateState] = useState({
    docId: "",
    action: "",
    partnerTypeValue: "",
    partnerValue: "",
    partnerId: "",
  });

  const [errorField, setErrorField] = useState({
    partnerTypeValue: "",
    partnerValue: "",
  });

  const { docId, action, partnerId } = iState;

  //***************User Details by solar************** */
  const handelUserDetails = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/solarRequest/user?userId=${id}`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        setUser(res.data.data || {});
        //set user coordinates
        let coordinates = res.data.data.coordinates;
        let coorArray = [];
        if (coordinates) {
          for (let i = 0; i < coordinates.length; i++) {
            coorArray.push([coordinates[i].lat, coordinates[i].lng]);
          }
        }
        setCordinates(coorArray);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************User Details by id************** */
  const handleSingleUserDetails = async () => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/userDetails?userId=${id}`,
        method: "GET",
      });
      hideLoader();
      if (res.status === 200) {
        setUser(res.data.data || {});
        //set user coordinates
        let coordinates = res.data.data.coordinates;
        let coorArray = [];
        if (coordinates) {
          for (let i = 0; i < coordinates.length; i++) {
            coorArray.push([coordinates[i].lat, coordinates[i].lng]);
          }
        }
        setCordinates(coorArray);
      }
    } catch (err) {
      console.log(err);
    }
  };
  //************Handel Action Request*********** */
  const [ActionModal, setActionModal] = useState(false);
  const handleActionRequestClose = () => {
    setActionModal(false);
  };
  const handleActionRequestOpen = (action, partnerId) => {
    updateState({ ...iState, partnerId: partnerId, action: action });
    setActionModal(true);
  };
  const handelActionRequest = async () => {
    try {
      //console.log(partnerId, action);return false;
      const res = await axios({
        url: `${Url}/solarRequest/approvedByAdmin`,
        method: "POST",
        data: {
          userId: id,
          financialPartnerId: partnerId,
          approvedByAdminStatus: action,
        },
      });
      console.log(res.data);
      handleActionRequestClose();
      if (res.data.status === 200) {
        handelUserDetails();
        toast.success("Request has been " + action + "  successfully");
      } else {
        toast.error("Something wents wrong, please try again");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something wents wrong, please try again");
    }
  }; //*********Refer Action Modal********* */
  const [ReferActionModal, setReferActionModal] = useState(false);
  const [ReferToFincancialActionModal, setReferToFincancialActionModal] =
    useState(false);
  const [RequestType, setRequestType] = useState();
  const handelReferRequest = (type) => {
    setRequestType(type);
    setReferActionModal(true);
  };

  const handelReferRequestClose = () => {
    setReferActionModal(false);
  };

  const handelFinancialReferRequestClose = () => {
    setReferToFincancialActionModal(false);
  };

  const handelActionRequestType = () => {
    if (RequestType === 1) {
      handelReferRequestClose();
      setReferToFincancialActionModal(true);
    } else {
      //console.log("Api called");
      handelReferalByVoltAdmin();
    }
  };

  //**************Handel Partner Type List ******** */
  const [partnerType, setPartnerType] = useState([]);
  const handelPartnerype = async () => {
    try {
      const res = await axios({
        url: `${Url}/solarRequest/financialPartner`,
        method: "GET",
      });
      if (res.data.status === 200) {
        setPartnerType(res.data.data.partnerTypeList);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went to wrong");
    }
  };

  //*********Handel Financial Partner********* */
  const [financialPartner, setFinancialPartner] = useState([]);

  const handelFinancialPartner = async (typeId) => {
    try {
      const res = await axios({
        url: `${Url}/solarRequest/selectType?financeCompanyType=${typeId}&userId=${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        //data: data,
      });

      if (res.data.status === 200) {
        //console.log("mydata", res.data.data);
        //*****Set option values*** */
        let responseData = res.data.data;
        var tempArray = [];
        if (responseData.length > 0) {
          for (var i = 0; i < responseData.length; i++) {
            var array = {
              name: responseData[i].financeCompanyName,
              id: responseData[i]._id,
            };

            tempArray.push(array);
          }
        }
        setFinancialPartner(tempArray);
        //******End of Options**** */
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went to wrong");
    }
  };

  const onSelect = (e) => {
    // console.log(e);
    updateState({ ...iState, partnerValue: e });
  };

  const onRemove = (e) => {
    //console.log("rem", e);
    updateState({ ...iState, partnerValue: e });
  };

  const resetDropdownValue = useRef();

  //*************** */
  const handelOnChange = (e) => {
    //reset selected value
    //resetDropdownValue.current.resetSelectedValues()
    updateState({ ...iState, partnerTypeValue: e.target.value });
    if (e.target.value !== "") {
      handelFinancialPartner(e.target.value);
    }
  };

  //*********Handel Validation********** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!iState.partnerTypeValue) {
      errorField["partnerTypeValue"] = "Please select Partner Type";
      formIsValid = false;
    }

    if (!iState.partnerValue) {
      errorField["partnerValue"] = "Please select Financial Partner";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };
  //********Final Submit*********** */
  const handelRefralSubmit = async () => {
    try {
      if (handleValidation()) {
        let resData = iState.partnerValue;
        let temp = [];
        for (var j = 0; j < resData.length; j++) {
          temp.push(resData[j].id);
        }

        let data = {
          financialPartnerByName: temp,
          userId: id,
          RefertoFinancialPartner: "ReferToFinance",
        };
        // console.log("data", data);
        //return false;
        console.log(data, data);
        const res = await axios({
          url: `${Url}/solarRequest/selectType`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        });
        console.log("res", res);
        if (res.data.status === 200) {
          handelFinancialReferRequestClose();
          handelUserDetails();
          toast.success(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went to wrong");
    }
  };

  //******Referal By Volt Admin******* */
  const handelReferalByVoltAdmin = async () => {
    try {
      // console.log(id);
      const res = await axios({
        url: `${Url}/solarRequest/refer`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          userId: id,
          RefertoFinancialPartner: "ReferToVolt",
        },
      });
      if (res.data.status === 200) {
        handelReferRequestClose();
        handelUserDetails();
        toast.success(res.data.message);
      }
    } catch (err) {
      toast.error("Something went to wrong");
    }
  };

  useEffect(() => {
    handelPartnerype();
    if (location.state.stepStatus) {
      handelUserDetails();
    }
    else {
      handleSingleUserDetails()
    }
  }, []);

  return (
    <React.Fragment>
      <title>Leads Details</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          {loader}
          <div className="Small-Wrapper">
            <h4 className="Title back_wrap">
              {" "}
              <Link to={`/marketing-partner/details/${marketingPartnerID}`} className="back_btn">
                <i className="fa fa-arrow-left"></i>
              </Link>
              User Details
            </h4>
            <div className="OrderArea">
              <ul>
                <li>
                  <span>Username</span>{" "}
                  {user.firstName && user.lastName
                    ? user.firstName + " " + user.lastName
                    : "- - -"}
                </li>
                <li>
                  <span>Company Name</span> {user.nameOfBusiness}
                </li>
                <li>
                  <span>Nature of Business</span> {user.natureOfTheBusiness}
                </li>
                <li>
                  <span>Average of Monthly Bill</span> {user.avgMonBill}
                </li>
                <li>
                  <span>Average Profitability of Business in Last 5 Years</span>{" "}
                  {user.AvgProfitlastFiveYear}
                </li>
                <li>
                  <span>Contact Number</span> {user.contactNum}
                </li>
                <li>
                  <span>Company Pan Number</span> {user.companyPan}
                </li>
                <li>
                  <span>State</span> {user.stateName}
                </li>
                <li>
                  <span>Address</span> {user.address}
                </li>
              </ul>
            </div>
          </div>

          {
            location.state.stepStatus && <>
              {/* Mark of Roof area */}
              <div className="Small-Wrapper">
                <h4 className="Title">
                  Mark of Roof (Total Area ={" "}
                  {user.totalroofArea ? user.totalroofArea.toFixed(2) : 0} sqf)
                </h4>
                {/* <div className="OrderArea">
              {cordinates.length > 0 ? (
                <DrawPolygon data={cordinates} />
              ) : (
                "Loading..."
              )}
            </div> */}
              </div>
              {/* Document Details */}
              <div className="Small-Wrapper">
                <h4 className="Title">Document Uploaded </h4>
                <div className="OrderArea">
                  <div className="row">
                    {user &&
                      user.docsData &&
                      user.docsData.length > 0 &&
                      user.docsData.map((item, i) => (
                        <div className="col-md-4 upload_card" key={i}>
                          <p>{item.documentName}</p>
                          <p>
                            {item.docsType === "pdf" ? (
                              <>
                                <img src={Pdf} height="50" width="50" />
                              </>
                            ) : (
                              <>
                                {item.docsType === "jpg" ? (
                                  <img src={Jpg} height="50" width="50" />
                                ) : (
                                  <>
                                    {item.docsType === "jpeg" ? (
                                      <img src={Jpeg} height="50" width="50" />
                                    ) : (
                                      <img src={Png} height="50" width="50" />
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </p>
                          <p>
                            <button
                              className="button"
                              onClick={() => window.open(item.imageUrl, "_blank")}
                            >
                              Preview
                            </button>
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* Action on Request */}
              <div className="Small-Wrapper">
                <h4 className="Title">Actions On Request </h4>
                <div className="OrderArea">
                  {user.approvedByAdminStatus === "Pending" ? (
                    <>
                      <button
                        className="btn button"
                        onClick={() => {
                          handelReferRequest(1);
                        }}
                      >
                        Refer to Financial Partner
                      </button>

                      <button
                        className="btn button"
                        onClick={() => {
                          handleActionRequestOpen("Rejected", "");
                        }}
                      >
                        Reject Request
                      </button>
                    </>
                  ) : (
                    <>
                      {user.approvedByAdminStatus === "Rejected"
                        ? "Request Rejected"
                        : "Request Accepted"}
                    </>
                  )}

                  {user.approvedByAdminStatus === "Pending" &&
                    user.sendRequest &&
                    user.sendRequest.length > 0 ? (
                    <>
                      <br></br>
                      <b>Note:-</b> This application has been successfully Financed
                      by the Financial Partner.Please click button if you want
                      assign more partner.
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {user.RefertoFinancialPartner === "ReferToFinance" ? (
                <div className="Small-Wrapper">
                  <h4 className="Title">Request Assigned to Partner's </h4>
                  <div className="OrderArea">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact Number</th>
                          <th>Financial Partner Status</th>
                          <th>Accept Request</th>
                        </tr>
                      </thead>
                      <tbody>
                        {user.sendRequest &&
                          user.sendRequest.length > 0 &&
                          user.sendRequest.map((item, i) => (
                            <tr key={i}>
                              <td>{++i}</td>
                              <td>
                                <Link to={`/financial-partner/details/${item._id}`}>
                                  {item.financeCompanyName}
                                </Link>
                              </td>

                              <td>{item.email}</td>
                              <td>{item.contactNum}</td>
                              <td>
                                {item.status && item.status.length > 0
                                  ? item.status[0].status
                                  : "Pending"}
                              </td>
                              <td>
                                {item._id ===
                                  user.financePartnerIdApprovedByAdmin ? (
                                  "Request Accepted"
                                ) : (
                                  <>
                                    {user.approvedByAdminStatus === "Approved" ||
                                      user.approvedByAdminStatus === "Rejected" ? (
                                      "- - -"
                                    ) : (
                                      <>
                                        {item.status &&
                                          item.status.length > 0 &&
                                          item.status[0].status === "Accepted" ? (
                                          <button
                                            className="btn button"
                                            onClick={() => {
                                              handleActionRequestOpen(
                                                "Approved",
                                                item._id
                                              );
                                            }}
                                          >
                                            Accept Request
                                          </button>
                                        ) : (
                                          "- - -"
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : null}

            </>
          }



        </div>
      </div>
      {/* Popup model handel action request status */}
      <Modal show={ActionModal} onHide={handleActionRequestClose}>
        <Modal.Header closeButton onClick={handleActionRequestClose}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure want to confirm the request for this financial partner?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="secondary"
            variant="secondary"
            onClick={handleActionRequestClose}
          >
            No
          </button>
          <button
            className="primary"
            variant="primary"
            onClick={handelActionRequest}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      {/* Refer to Financial Partner */}
      <Modal show={ReferActionModal} onHide={handelReferRequestClose}>
        <Modal.Header closeButton onClick={handelReferRequestClose}>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {RequestType === 1
            ? "Are you sure want to refer to Refer to Financial Partner"
            : "Are you sure want to Financed By VOLT"}
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handelReferRequestClose}>
            No
          </button>
          <button variant="primary" onClick={handelActionRequestType}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={ReferToFincancialActionModal}
        onHide={handelFinancialReferRequestClose}
      >
        <Modal.Header closeButton onClick={handelFinancialReferRequestClose}>
          <Modal.Title>Refer to Financial Partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <select
                className="form-control"
                name="partnerType"
                onChange={(e) => {
                  handelOnChange(e);
                }}
              >
                <option value="">Select Type</option>
                {partnerType &&
                  partnerType.length > 0 &&
                  partnerType.map((type, i) => (
                    <option key={i} value={type._id}>
                      {type.financeCompanyType}
                    </option>
                  ))}
              </select>
              <span style={{ color: "red" }} className="error">
                {errorField.partnerTypeValue}
              </span>
            </div>
            <div className="col-md-12 mt-3">
              <Multiselect
                options={financialPartner}
                selectedValues=""
                ref={resetDropdownValue}
                onSelect={(e) => {
                  onSelect(e);
                }}
                onRemove={(e) => {
                  onRemove(e);
                }}
                displayValue="name"
              />
              <span style={{ color: "red" }} className="error">
                {errorField.partnerValue}
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button variant="primary" onClick={handelRefralSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
